import './LoadingState.scss';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import React from 'react';
import ListView from '../listview/ListView';
import {Poi} from '../../react-app-env';
import {getPoiCategoryIconCategory} from '../../utils/PoiCategoryUtils';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';

export interface LoadingStateProps {
  poi: Poi;
}

const LoadingState: React.FunctionComponent<LoadingStateProps> = ({ poi }) => {
  const iconCategory = getPoiCategoryIconCategory(poi.category);
  return <ListView>
    <ListViewGroup className="poi-details__loading-state">
      <div className="poi-details__loading-state__header-image"></div>
      <ListViewItem title=""
                    iconCategory={iconCategory}
                    decoration={DefaultItemDecorations.CHEVRON}/>
      <ListViewItem title=""
                    iconCategory="fa-folder fa-regular"
                    decoration={DefaultItemDecorations.CHEVRON}/>
      <ListViewItem title=""
                    iconCategory="fa-image fa-regular"
                    decoration={DefaultItemDecorations.EDIT}/>
    </ListViewGroup>
  </ListView>;
};

export default LoadingState;
